import { render, staticRenderFns } from "./LogisticsInfo.vue?vue&type=template&id=1be5c8dc&scoped=true"
import script from "./LogisticsInfo.vue?vue&type=script&lang=js"
export * from "./LogisticsInfo.vue?vue&type=script&lang=js"
import style0 from "./LogisticsInfo.vue?vue&type=style&index=0&id=1be5c8dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be5c8dc",
  null
  
)

export default component.exports